module.exports = __webpack_public_path__ + "img/object-spinning-top.757cf71.svg";